import React from 'react'
import {Link} from 'gatsby'

import styles from './ReadMore.module.css'

function ReadMore (props) {
  const {relatedArticles} = props
  return (
    <div className={styles.relatedArticles}>
      <h3 className={styles.relatedArticlesHeadline}>Les mer</h3>
      <ul className={styles.articleLinks}> {relatedArticles.map(article => (
        <li className={styles.articleLink} key={`related_${article._id}`}>
          {article.slug ? (
            <Link to={`/artikkel/${article.slug.current}`}>{article.title}</Link>
          ) : (
            <span>{article.title}</span>
          )}
        </li>
      ))}
      </ul>
    </div>)
}

export default ReadMore
